import * as React from 'react';
import { loadingScheduler } from '../../../services/loading-scheduler';

export class LazyChatRoomScreen extends React.Component<any> {
  ChatRoomScreen;
  Branding;
  mounted = false;

  componentDidMount() {
    this.mounted = true;

    void loadingScheduler.onInteractive().then(async () => {
      this.ChatRoomScreen = (
        await import(
          /* webpackChunkName: "chat-interactivity" */ '@wix/chat-web/dist/src/components/ChatRoomScreen/ChatRoomScreen'
        )
      ).default;
      this.Branding = (
        await import(
          /* webpackChunkName: "chat-interactivity" */ '../../Branding/Branding'
        )
      ).default;

      if (this.mounted) {
        this.forceUpdate();
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    return this.ChatRoomScreen ? (
      <this.ChatRoomScreen
        {...this.props}
        banner={this.props.banner === true ? <this.Branding /> : undefined}
      />
    ) : (
      <div />
    );
  }
}
